import { getValueFromJson } from '../helpers/jsonParser';
import { Ii18n } from './interfaces/Ii18n';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export class i18n implements Ii18n {
    static multipleLanguageDictionary: any = {};
    static selectedLanguage: string | null = null;
    static standaloneLanguageDictionary: any = {};
    /**
     * Initialize the language.
     * @param dictionary The JSON language dictionary.
     * @param lang Language code. This config is required only if you are initializing multiple languages.
     * If parsing only one language, please ignore this parameter.
     */
    static initialize(dictionary: unknown, lang: string | null = null): void {
        i18n.selectedLanguage = lang;
        if (i18n.selectedLanguage !== null) {
            i18n.multipleLanguageDictionary[i18n.selectedLanguage as string] = dictionary;
        } else {
            i18n.standaloneLanguageDictionary = dictionary;
        }
    }

    /**
     * Get the translation text for language
     * @param key Key can be dot seperated in case of multi level json.
     * @param lang Language code.
     * @returns Translation text.
     */
    static t(key: string, lang: string | null = null): string {
        if (i18n.selectedLanguage === null) {
            return i18n.__getTranslationText(i18n.standaloneLanguageDictionary, key);
        } else if (lang === null) {
            return i18n.__getTranslationText(i18n.multipleLanguageDictionary[i18n.selectedLanguage], key);
        } else {
            return i18n.__getTranslationText(i18n.multipleLanguageDictionary[lang as string], key);
        }
    }

    /**
     * Set language to be selected for get method.
     * This methd will work after intitialization with language and also with multiple languages initialized.
     * @param lang Language code
     */
    static setLanguage(lang: string): void {
        i18n.selectedLanguage = lang;
    }

    static __getTranslationText(dictionary: unknown, key: string): string {
        const translation = getValueFromJson(dictionary, key);
        if (Array.isArray(translation)) {
            return translation.toString();
        }
        if (typeof translation !== 'string') {
            return key;
        }

        return translation;
    }

    /**
     * get a translated string for a given key and optional language.
     * @param key - The key for the desired translation.
     * @param lang - (Optional) The language code. Defaults to null.
     * @returns The translated string.
     */
    static getTranslatedString(key: string, lang: string | null = null): string {
        const dictionary =
            i18n.selectedLanguage === null
                ? i18n.standaloneLanguageDictionary
                : (lang === null && i18n.multipleLanguageDictionary[i18n.selectedLanguage]) ||
                  i18n.multipleLanguageDictionary[lang as string];
        const translation = getValueFromJson(dictionary, key);
        return JSON.stringify(translation || key);
    }
}
